<form class="register-form" #form="ngForm" (ngSubmit)="submit()" novalidate>

  <!-- ─── Header ───────────────────────────────────────────────────────────── -->
  <div class="modal-header">
    <h5 class="modal-title fw-bold">{{ title | slice:0:1 | uppercase }}{{ title | slice:1 }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
  </div>

  <div class="modal-body p-3">

    <!-- ─── Contexte hébergement ───────────────────────────────────────────── -->
    <div class="alert alert-info py-2 px-3 mb-3 d-flex gap-3 align-items-center" style="font-size:13px;">
      <i class="fa fa-bed me-1"></i>
      <span><strong>Client :</strong> {{ itemToSave.client_nom }} / {{ itemToSave.client_telephone }}</span>
      <span class="ms-3"><strong>Chambre :</strong> {{ itemToSave.chambre_libelle }}</span>
    </div>

    <!-- ─── Contenu principal : Grille gauche | Panier droite ──────────────── -->
    <div class="row g-3">

      <!-- ── Gauche : articles à choisir ─────────────────────────────────── -->
      <div class="col-md-7">

        <!-- Magasin + Recherche article -->
        <div class="row g-2 mb-2">
          <div class="col-md-6">
            <ng-select name="magasin_stock_id" [items]="itemsMagasin" bindLabel="libelle" bindValue="id"
              placeholder="-- Sélectionner un magasin --" [(ngModel)]="itemToSave.magasin_stock_id"
              (change)="onSelectMagasin()" [clearable]="true">
            </ng-select>
          </div>
          <div class="col-md-6">
            <div class="input-group">
              <input type="text" class="form-control" [(ngModel)]="article_search" name="article_search"
                placeholder="Rechercher un article..." autocomplete="off"
                style="height: 40px; font-size: 14px; border: 1px solid #ced4da; width:100%" />
              <button type="button" class="btn btn-outline-secondary" *ngIf="article_search" (click)="article_search = ''">
                <i class="fa fa-times"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- Grille articles -->
        <div style="max-height: 420px; overflow-y: auto; overflow-x: hidden;">
          <div class="row g-2">
            <div class="col-xl-3 col-md-4 col-sm-6 col-6" *ngFor="let article of filteredArticles">
              <div class="card h-100 position-relative" [class.border-primary]="isInCart(article)"
                [class.opacity-50]="article.quantite_en_stock <= 0" style="transition: box-shadow .15s;">
                <span *ngIf="isInCart(article)" class="badge bg-primary position-absolute top-0 end-0 m-1"
                  style="z-index:1; font-size:10px;">
                  × {{ getCartQty(article) }}
                </span>
                <img [src]="article.image_url || 'assets/images/default/default.avif'" class="card-img-top"
                  style="height: 80px; object-fit: cover;" alt="" />
                <div class="card-body p-1">
                  <div class="fw-bold text-truncate" style="font-size:11px;" [title]="article.libelle">
                    {{ article.libelle }}
                  </div>
                  <div class="text-primary fw-bold" style="font-size:12px;">
                    {{ article.prix_vente | IntegerFormatPipe }}
                  </div>
                  <span class="badge" style="font-size:9px;" [class.bg-success]="article.quantite_en_stock > 5"
                    [class.bg-warning]="article.quantite_en_stock > 0 && article.quantite_en_stock <= 5"
                    [class.bg-danger]="article.quantite_en_stock <= 0">
                    Stock: {{ article.quantite_en_stock }}
                  </span>
                </div>
                <div class="card-footer p-1">
                  <button type="button" class="btn btn-sm btn-primary w-100" style="font-size:11px; padding:2px 0;"
                    (click)="addToCart(article)" [disabled]="article.quantite_en_stock <= 0">
                    <i class="fa fa-cart-plus"></i> Ajouter
                  </button>
                </div>
              </div>
            </div>
            <div *ngIf="!filteredArticles.length" class="col-12 text-center text-muted py-4">
              <i class="fa fa-box-open fa-2x d-block mb-2"></i>
              Aucun article trouvé
            </div>
          </div>
        </div>
      </div>

      <!-- ── Droite : articles choisis + résumé ──────────────────────────── -->
      <div class="col-md-5 d-flex flex-column" style="max-height: 460px;">

        <!-- Liste panier -->
        <div style="flex:1; overflow-y: auto; min-height: 0;">

          <!-- En-tête -->
          <div class="d-flex align-items-center justify-content-between mb-2">
            <span class="fw-bold" style="font-size:13px;">
              <i class="fa fa-shopping-cart me-1 text-primary"></i>
              Panier
              <span class="badge bg-primary ms-1" *ngIf="itemsCommandeDetailToSave.length">
                {{ itemsCommandeDetailToSave.length }}
              </span>
            </span>
          </div>

          <!-- Items -->
          <div *ngFor="let item of itemsCommandeDetailToSave; let j = index"
            class="d-flex align-items-center gap-2 p-2 mb-2 border rounded bg-white"
            style="box-shadow: 0 1px 3px rgba(0,0,0,.06);">

            <img [src]="item.article_image_url || 'assets/images/default/default.avif'"
              style="width:50px; height:50px; object-fit:cover; border-radius:6px; flex-shrink:0;" alt="" />

            <div style="flex:1; min-width:0;">
              <div class="fw-bold text-truncate" style="font-size:12px;">{{ item.article_libelle }}</div>
              <div class="text-muted text-truncate" style="font-size:10px;">{{ item.article_description }}</div>
              <div class="text-primary fw-bold" style="font-size:11px;">{{ item.total | IntegerFormatPipe }}</div>
            </div>

            <!-- Quantité −/+ -->
            <div class="d-flex align-items-center border rounded" style="flex-shrink:0;">
              <button type="button" class="btn btn-link btn-sm px-2 py-0 text-dark text-decoration-none"
                style="font-size:16px; line-height:1.4;" (click)="decrementCartQty(item, j)">−</button>
              <input type="number" class="border-0 text-center fw-bold"
                style="width:32px; font-size:12px; outline:none;" [(ngModel)]="item.quantite" [name]="'qty_' + j"
                (change)="onCartQtyChange(item)" min="1" />
              <button type="button" class="btn btn-link btn-sm px-2 py-0 text-dark text-decoration-none"
                style="font-size:16px; line-height:1.4;" (click)="incrementCartQty(item)">+</button>
            </div>

            <!-- Supprimer -->
            <button type="button" class="btn btn-sm text-muted p-0"
              style="font-size:18px; line-height:1; background:none; border:none; flex-shrink:0;"
              (click)="itemsCommandeDetailToSave.splice(j, 1)" title="Retirer">×</button>
          </div>

          <!-- Panier vide -->
          <div *ngIf="!itemsCommandeDetailToSave.length" class="text-center text-muted py-5 border rounded">
            <i class="fa fa-shopping-cart fa-2x d-block mb-2 opacity-25"></i>
            <small>Ajoutez des articles depuis la grille</small>
          </div>
        </div>

        <!-- Résumé fixe en bas -->
        <div class="border rounded p-3 mt-2 bg-white" style="flex-shrink:0; box-shadow:0 1px 4px rgba(0,0,0,.06);">
          <div class="d-flex justify-content-between mb-1" style="font-size:13px;">
            <span class="text-muted">Articles</span>
            <span class="fw-bold">{{ itemsCommandeDetailToSave.length }}</span>
          </div>
          <div class="d-flex justify-content-between mb-2" style="font-size:13px;">
            <span class="text-muted">Sous-total</span>
            <span class="fw-bold">{{ cartTotal | IntegerFormatPipe }}</span>
          </div>
          <hr class="my-2" />
          <div class="d-flex justify-content-between mb-3" style="font-size:15px;">
            <span class="fw-bold">Total</span>
            <span class="fw-bold text-primary">{{ cartTotal | IntegerFormatPipe }}</span>
          </div>
          <button type="button" class="btn btn-primary w-100"
            [disabled]="isLoading || !itemsCommandeDetailToSave.length" (click)="confirmSaveItem(itemToSave)">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1"></span>
            <i *ngIf="!isLoading" class="fa fa-check me-1"></i>
            Enregistrer la commande
          </button>
        </div>

      </div>
    </div>

  </div><!-- end modal-body -->

  <div class="modal-footer py-2">
    <button type="button" class="btn btn-secondary btn-sm" (click)="activeModal.dismiss()">Fermer</button>
  </div>

</form>